import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="mb-12">
      <h1 className="text-4xl font-serif font-bold text-dark">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-4 text-lg text-dark/80">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageHeader;